import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';

import OptionButton from '@/components/common/OptionButton/OptionButton';
import ArrowIcon from '@/components/common/OptionButton/icons/Arrow/ArrowIcon';
import ContractIqVerifyModal from '../../../ContractIq/components/ContractIqVerifyModal/ContractIqVerifyModal';
import { fieldVerificationRefreshTrigger } from '../../../ContractIq/ContractIq.state';

export default function ContractIqVerifyContainer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const setRefreshTrigger = useSetRecoilState(fieldVerificationRefreshTrigger);

  return (
    <>
      <OptionButton
        onClick={() => setIsModalOpen(true)}
        Icon={<ArrowIcon />}
      >
        ContractIQ Verify
      </OptionButton>

      {isModalOpen && (
        <ContractIqVerifyModal
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            setRefreshTrigger((prev) => prev + 1);
          }}
        />
      )}
    </>
  );
}
